module.exports = "<p-fieldset legend=\"Capacitadora\">\r\n  <div class=\"ui-g-12\">\r\n    <base-info text=\"Capacitadora\" class=\"ui-g-12 ui-md-6\" [value]=\"capacitadora?.nome\"></base-info>\r\n\r\n    <base-info text=\"Código\" class=\"ui-g-12 ui-md-6\" [value]=\"capacitadora?.codigo\"></base-info>\r\n  </div>\r\n</p-fieldset>"


//////////////////
// WEBPACK FOOTER
// ./src/app/field-set-capacitadora/field-set-capacitadora.component.html
// module id = ./src/app/field-set-capacitadora/field-set-capacitadora.component.html
// module chunks = main